import './hermanmiller/style';
import FormStructure from './hermanmiller/form_structure';

export default FormStructure;